export default __webpack_public_path__ + "static/media/the_pope_video.5d297a1c.svg";